// Library methods
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

// MUI Components
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import SearchBox from "../SearchBox";
import DefaultModal from "../DefaultModal";

// Styles
import {
  ModalCustomCancel,
  ModalCustomConfirm,
} from "../../../styles/muiStylesHelper";

const LinkDeviceModal = ({
  open,
  onClose,
  onConfirm,
  onCancel,
  devicesOptions = [],
  editExamDevice,
  setEditExamDevice,
  loading,
}) => {
  // internationalization
  const { t } = useTranslation();

  const formattedDevicesOptions = useMemo(
    () =>
      devicesOptions.map((option) => {
        return { name: option?.alias, val: option?.id };
      }),
    [devicesOptions]
  );

  const shouldDisable = useMemo(() => {
    let isIncluded = false;
    devicesOptions.forEach((option) => {
      if (option?.id === editExamDevice?.val) isIncluded = true;
    });
    return !isIncluded;
  }, [devicesOptions, editExamDevice?.val]);

  return (
    <DefaultModal
      isOpen={open}
      onClose={onClose}
      title={t("device_link_modal_title")}
      maxWidth="xs"
      modalActions={
        <Grid
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "20px",
          }}
        >
          <Button variant="text" sx={ModalCustomCancel} onClick={onCancel}>
            {t("button_cancel")}
          </Button>
          <Button
            variant="outlined"
            sx={ModalCustomConfirm}
            disabled={shouldDisable || loading}
            onClick={onConfirm}
          >
            {t("button_link")}
          </Button>
        </Grid>
      }
    >
      <Grid display="flex" flexDirection="column" p="20px" gap="20px">
        {/* Device selector */}
        <SearchBox
          data={formattedDevicesOptions}
          state={editExamDevice}
          setState={setEditExamDevice}
          label={t("device_link_modal_devices")}
          propertyBit={4}
        />
      </Grid>
    </DefaultModal>
  );
};

export default LinkDeviceModal;
